var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseWn3O6Qr6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: 300,
    height: 300,
    viewBox: "0 0 1920 1920",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M754.571 0v1920H206V0h548.571zm960 0v1920H1166V0h548.571z",
    fillRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyBmaWxsPSIjZmZmIiB3aWR0aD0iMzAwcHgiIGhlaWdodD0iMzAwcHgiIHZpZXdCb3g9IjAgMCAxOTIwIDE5MjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNzU0LjU3MSAwdjE5MjBIMjA2VjBoNTQ4LjU3MVptOTYwIDB2MTkyMEgxMTY2VjBoNTQ4LjU3MVoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4=";
export { SvgPauseWn3O6Qr6 as ReactComponent };